import React, { Component } from 'react';

class Temoincard extends Component {
    render() {
        return (
            <div className="temoinCard d-flex flex-column align-items-center">
                <img src={this.props.img} width="70px" height="70px" alt="" />
                <span className='home__txt  sponsored decvr__links px-3'>{this.props.comment}</span>
                <p className='decvr__txt'>{this.props.temoin}</p>
                <h6 className='home__txt'>{this.props.name}</h6>
            </div>
        );
    }
}

export default Temoincard;
